import React, {useState} from "react";
import './PhoneMenu.css';
import close_menu from "../../../../static/img/Header/close.svg";
import bamb_menu from "../../../../static/img/Header/menuIn.svg";
import ChangeLink from "../../../../Elements/ChangeLink/ChangeLink";
import MainMenuArray from "../../MainMenu";


const SubmenuWork = (Submenu,lang) => { // Правила по которым создается новый массив при окончании перемещения элементов мышкой
    const result = Array.from(Submenu);
    return result.map(function(SubMenuElement,index) {
        return (
            <div key={index} className="phoneMenuMainElementSubMenuElement">
                <ChangeLink lang={lang} to={SubMenuElement.href} activeClassName="phoneMenuMainElementSubMenuElement phoneMenuMainElementSubMenuElementActive" style={{textDecoration: 'none'}}>{SubMenuElement.Name[lang]}</ChangeLink>
            </div>

        )
    });};

    function PhoneMenu(props){
        const topMenu = (A,self) => MainMenuArray.map(function(MenuElement,index) {
            // console.log('topMenu',MenuElement.Name[props.lang]);
            let ActiveElement = '';
            if (index===A)   {ActiveElement = 'phoneMenuMainElementActive'}
            return (
                <div key={index} className={"phoneMenuMainElement " + ActiveElement}>
                    <div className="phoneMenuMainElementTitle" onClick={() => MakeVisibleThisMenu(index)} role="button" tabIndex={0} onKeyPress={() => {}}>
                        <div>{MenuElement.Name[props.lang]}</div>
                        <div className="phoneMenuMainElementTitleImgClose" role="button" tabIndex={0} onKeyPress={() => {}}>
                            {/*<img src={backDown} width="8" height="8" alt='alt'/>*/}
                        </div>
                        <div className="phoneMenuMainElementTitleImgOpen" role="button" tabIndex={0} onKeyPress={() => {}}>
                            {/*<img src={backUp} width="8" height="8" alt='alt'/>*/}

                        </div>

                    </div>
                    <div className="phoneMenuMainElementSubMenu">
                        {SubmenuWork(MenuElement.Submenu,props.lang)}
                    </div>
                </div>
            )});

        const [SmallMenuVisible, setSmallMenuVisible] = useState('isNoVisible');
        const [Active, setActive] = useState(props.Active);

        function MakeInVisibleMenu(){setSmallMenuVisible('isNoVisible');};

        function MakeVisibleMenu(){setSmallMenuVisible('isVisible');}

        function MakeVisibleThisMenu(idActive) {setActive(idActive)}

            return (
      <div className="menu_header_small">
          <div onClick={() => MakeVisibleMenu()} role="button" tabIndex={0} onKeyPress={() => {}}><img src={bamb_menu} width="40px" height="40px" alt='alt'/></div>

          <div className={"for_cab " + SmallMenuVisible}  role="button" tabIndex={0} onKeyPress={() => {}} onClick={() => MakeInVisibleMenu()}> </div>

          <div className={"phoneMenu " + SmallMenuVisible}>
              <div className="phoneMenuTopButtons"><div  onClick={() => MakeInVisibleMenu()}  role="button" tabIndex={0} onKeyPress={() => {}}>
                      <img src={close_menu}  width="25" height="25" alt='alt' /></div>
              </div>
              <div className="phoneMenuThreeButtons">
                  <div className="phoneMenuThreeButtonsElement"><ChangeLink lang={props.lang} to='/trader/open/'  style={{textDecoration: 'none'}}>Открыть счет</ChangeLink></div>
                  <div className="phoneMenuThreeButtonsElement"><ChangeLink lang={props.lang} to='/trader/deposit/'  style={{textDecoration: 'none'}}>Пополнить</ChangeLink></div>
                  <div className="phoneMenuThreeButtonsElement"><ChangeLink lang={props.lang} to='/trader/withdrawal/'  style={{textDecoration: 'none'}}>Снять прибыль</ChangeLink></div>
              </div>

              <div className="phoneMenuMain">
                  {topMenu(Active,this)}
              </div>
          </div>
      </div>
)}

export default PhoneMenu


